import {Component, OnInit} from '@angular/core';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {MatDialogRef} from '@angular/material/dialog';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {LocalStorageService} from 'src/app/local-storage.service';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'app-service-synchronisation',
    templateUrl: './service-synchronisation.component.html',
    styleUrls: ['./service-synchronisation.component.scss'],
})
export class ServiceSynchronisationComponent implements OnInit {
    public totalDocuments: BehaviorSubject<number> = new BehaviorSubject(0);
    public downloadedDocuments: BehaviorSubject<number> = new BehaviorSubject(0);
    public progressValue: BehaviorSubject<number> = new BehaviorSubject(0);
    public content: string = 'Starte Synchronisation';
    public showOKButton: boolean = false;
    public showCancelButton: boolean = true;
    private sa_Config?: ServiceAppModels.SA_Config;

    constructor(
        private svcSA: ServiceAppService,
        public dialogRef: MatDialogRef<ServiceSynchronisationComponent>,
        private localStorageService: LocalStorageService,
        private svcMessageBox: MessageBoxService
    ) {
        this.svcSA.registerSASyncStateFunc(this.updateSyncState.bind(this));
        this.svcSA.registerSASyncStateProgressBarFunc(
            this.updateSyncStateProgressbar.bind(this)
        );
        this.svcSA.registerSASyncStateDocuFunc(
            this.updateSyncStateDocuments.bind(this)
        );
    }

    ngOnInit(): void {
        this.svcSA.getCurrentSAConfig().subscribe({
            next: async (res) => {
                if (res) {
                    // Hier wird die serverseitige Konfiguration neu geladen. Diese hat Einfluss auf den Up- & Download.
                    this.sa_Config = res;
                    // Hier werden die Daten hochgeladen (Positionen, Objekte, Rapporte, Dokumente, Checklisten)
                    if (await this.startUpload()) {
                        // Hier werden die Stammdaten vom Server neu heruntergeladen.
                        if (await this.startDownload()) {
                            await this.localStorageService.add('last_SA_sync', new Date(), 'SwissWebConfigDB', false, true);
                        }
                    } else {
                        const res2 = await this.svcMessageBox.askYesNoQuestion('MAIN_APP_DIALOG.SYNC_FAIL_START_DOWNLOAD.msg', 'MAIN_APP_DIALOG.SYNC_FAIL_START_DOWNLOAD.title');
                        if (res2) {
                            if (await this.startDownload()) {
                                await this.localStorageService.add('last_SA_sync', new Date(), 'SwissWebConfigDB', false, true);
                            }
                        }
                    }
                }
            },
            error: (error) => {
                console.error(error);
                this.svcMessageBox.showError(
                    'Die Konfiguration der Service-App konnte nicht ermittelt werden!!',
                    '!! FEHLER !!'
                );
            },
        });
    }

    async startUpload(): Promise<boolean> {
        if (await this.svcSA.startUploadData()) {
            return await this.cleanData();
        } else {
            await this.cleanData();
            return false;
        }
    }

    async cleanData(): Promise<boolean> {
        return await this.svcSA.startCleanData();
    }

    async startDownload(): Promise<boolean> {
        const res = await this.svcSA.startDownloadData();
        if (res) {
            await this.svcMessageBox.showSuccessOK('MAIN_APP_DIALOG.OK_DIALOG.SYNC_SUCCESS.text', 'MAIN_APP_DIALOG.OK_DIALOG.SYNC_SUCCESS.title');
            this.closeDialog();
        } else {
            await this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.SYNC_ERROR.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.SYNC_ERROR.title');
        }
        this.showCancelButton = false;
        this.showOKButton = true;
        return true;
    }

    updateSyncState(message: string) {
        this.content += '\n' + message;
    }

    updateSyncStateProgressbar(value: number) {
        this.progressValue.next(value);
    }

    updateSyncStateDocuments(anzahl: number, total: number) {
        this.downloadedDocuments.next(anzahl);
        this.totalDocuments.next(total);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    cancelSync() {
        this.svcSA.cancelSync();
        this.showOKButton = true;
        this.showCancelButton = false;
    }
}
